import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFile from '../Shared/ChunkedUploadFile';
import './NewAdministrationUploadFile.css';

const NEW_ADMINISTRATION_ROOT =
  process.env.REACT_APP_ADMIN_START_PATH || '/new-administration';

function NewAdministrationUploadFile({
  currentPath,
  userId,
  onFileUploaded,
}) {
  return (
    <ChunkedUploadFile
      currentPath={currentPath}
      userId={userId}
      onFileUploaded={onFileUploaded}
      rootPath={NEW_ADMINISTRATION_ROOT}
      sessionPrefix="new_administration_file"
    />
  );
}

NewAdministrationUploadFile.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFileUploaded: PropTypes.func,
};

export default NewAdministrationUploadFile;
